var render = function render(){var _vm=this,_c=_vm._self._c;return _c('staff-message-modal',{key:_vm.messageKey,ref:"sendAMessage",attrs:{"sender-id":_vm.senderId,"roles":_vm.roles}})
}
var staticRenderFns = []

export { render, staticRenderFns }